const ScrollToTopBtn = document.getElementById( 'ScrollToTopBtn' );

if ( ScrollToTopBtn ) {
	ScrollToTopBtn.addEventListener( 'click', () => {
		window.scrollTo( { top: 0, behavior: 'smooth' } );
	} );
}
